import * as actionTypes from '../actions/actionTypes';
import {updatedObject} from '../../shared/utility';

const initialState = {
    ingredients: null,
    totalPrice: 3.85,
    error: false,
    building: null
    
};

const INGREDIENT_PRICES = {
    salad: 0.5,
    cheese: 0.4,
    meat: 1.3,
    bacon: 0.7,
    tomato: 0.8,
    onion: 0.55
}

const addIngredient = (state, action) => {
    const updatedIngredient = {[action.ingredientName]: state.ingredients[action.ingredientName] + 1};
            const updatedIngredients = updatedObject(state.ingredients,updatedIngredient);
            const updatedState = {
                ingredients: updatedIngredients,
                totalPrice: state.totalPrice + INGREDIENT_PRICES[action.ingredientName],
                building: true
          }
          return  updatedObject(state, updatedState);
};

const removeIngredient = (state, action) => {
    const updatedIng = {[action.ingredientName]: state.ingredients[action.ingredientName] - 1};
    const updatedIngs = updatedObject(state.ingredients,updatedIng);
    const updatedSt = {
        ingredients: updatedIngs,
        totalPrice: state.totalPrice + INGREDIENT_PRICES[action.ingredientName],
        building: true
  }
  return  updatedObject(state, updatedSt);
};  
const setIngredient = (state, action) => {
    return updatedObject(state, {
        ...state,
        ingredients: action.ingredients,
        totalPrice: 3.85,
        error: false, //in case of an earlier error occurring
        building: false
      });
}
const fetchIngredientsFailed = (state, action) => {
    return  updatedObject(state, {error: true});
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        //type is required by the redux pkg
        case actionTypes.ADD_INGREDIENT: return addIngredient(state, action);
        case actionTypes.REMOVE_INGREDIENT: return removeIngredient(state, action);
        case  actionTypes.SET_INGREDIENTS: return setIngredient(state, action);
        case  actionTypes.FETCH_INGREDIENTS_FAILED: return fetchIngredientsFailed(state, action);
             
          default:  
          return state; 
    }
};

export default reducer;